import VendorsProvider from '@/services/VendorsProvider'
import ProductsProvider from '@/services/ProductsProvider'

import _ from 'lodash'

export default {
  data () {
    return {
      vendors: [],
      selectedVendor: null,
      productsForVendor: [],
      selectedProduct: null,
      warning: null
    }
  },
  methods: {
    productAndVendorNotSelected () {
      return this.selectedVendor === null || this.selectedProduct === null
    },
    applySelectedVendor (selectedVendor) {
      return new Promise((resolve) => {
        if (selectedVendor !== null) {
          if (!selectedVendor.vendorRefreshed) {
            this.refreshVendor(selectedVendor)
          }
          this.refreshProducts(selectedVendor)
        }
        this.selectedProduct = null
        resolve(selectedVendor)
      })
    },
    refreshProducts (selectedVendor) {
      if (selectedVendor === null) {
        this.productsForVendor = []
        return
      }
      ProductsProvider.all({vendorId: selectedVendor.id})
        .then((resp) => {
          this.productsForVendor = resp.body.products.map((product) => {
            return { id: product.id, label: product.name }
          })
        })
    },
    refreshVendor (selectedVendor) {
      VendorsProvider.get(selectedVendor.id)
        .then((resp) => {
          this.selectedVendor = {
            ...this.selectedVendor,
            salesforceLink: resp.body.salesforce_link,
            vendorRefreshed: true
          }
        }).catch(error => {
          this.warning = (error.body && error.body.errors && error.body.errors[0]) || error.statusText || 'Error getting Vendor details'
        })
    },
    onSearch (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.search(loading, search, this)
      }
    },
    search: _.debounce((loading, search, vm) => {
      VendorsProvider.autocomplete(search)
        .then(res => {
          res.json().then(json => {
            if (json.warning != null) {
              vm.warning = json.warning
            } else {
              vm.warning = null
            }
            vm.vendors = json.data.map(row => ({id: +row.id, label: row.label}))
          })
        }).catch(error => {
          console.log(error)
          vm.warning = 'Vendors could not be retrieved.'
        })
      loading(false)
    }, 500)
  }
}
